import { Model, Snake, DyingSnake, speed } from '../server-src/model'
import { cloneDeep } from 'lodash-es'

function lerp(start: number, end: number, t: number) {
  return start * (1 - t) + end * t
}

function last<T>(arr: T[]) {
  return arr[arr.length - 1]
}

function secondLast<T>(arr: T[]) {
  return arr[arr.length - 2]
}

function interpolateSnakes(
  s1: DyingSnake,
  s2: DyingSnake,
  r: number
): DyingSnake
function interpolateSnakes(s1: Snake, s2: Snake, r: number): Snake
function interpolateSnakes(
  s1: Snake | DyingSnake,
  s2: Snake | DyingSnake,
  r: number
): Snake | DyingSnake {
  let jointLengthsLength = s2.jointLengthsLength
  let jointLengths = [...s2.jointLengths]
  let head = [...s2.head] as [number, number]
  let initialDirectionVertical = s2.initialDirectionVertical
  if (s1.jointLengthsLength === s2.jointLengthsLength) {
    jointLengths[jointLengths.length - 1] = lerp(
      last(s1.jointLengths),
      last(s2.jointLengths),
      r
    )
    head[0] = lerp(s1.head[0], s2.head[0], r)
    head[1] = lerp(s1.head[1], s2.head[1], r)
  } else if (s2.jointLengthsLength === s1.jointLengthsLength + 1) {
    const firstLen = Math.abs(
      secondLast(s2.jointLengths) - last(s1.jointLengths)
    )
    const secondLen = Math.abs(last(s2.jointLengths))
    // console.log({ s1, s2, firstLen, secondLen, r })
    const total = firstLen + secondLen
    if (r <= firstLen / total) {
      jointLengthsLength = s1.jointLengthsLength
      jointLengths = [...s1.jointLengths]
      head = [...s1.head] as [number, number]
      initialDirectionVertical = s1.initialDirectionVertical

      //todo
      const diff = total * r * Math.sign(last(jointLengths))
      jointLengths[jointLengths.length - 1] += diff
      const dim = s1.initialDirectionVertical ? 1 : 0
      head[dim] += diff

      // const diff = total * r * Math.sign(last(jointLengths))
      // jointLengths[jointLengths.length - 1] += diff
      // const dim = s1.initialDirectionVertical ? 1 : 0
      // head[dim] += diff
    } else {
      const diff = total * (1 - r) * Math.sign(last(jointLengths))
      jointLengths[jointLengths.length - 1] -= diff
      const dim = s2.initialDirectionVertical ? 1 : 0
      head[dim] += diff
      // console.log('hi')
    }
  }
  const sn: Snake = {
    jointLengths,
    jointLengthsLength,
    head,
    initialDirectionVertical,
    length: r < 0.5 ? s1.length : s2.length,
    id: s2.id,
    color: s2.color,
    name: s2.name,
    spawnTime: s2.spawnTime,
    kills: r < 0.5 ? s1.kills : s2.kills,
  }
  // console.log({ s1, s2, sn })
  if ('alpha' in s1)
    return { ...sn, alpha: lerp(s1.alpha, (s2 as DyingSnake).alpha, r) }
  else return sn
}

function interpolateSnakesLists(
  z1: DyingSnake[],
  z2: DyingSnake[],
  r: number
): DyingSnake[]
function interpolateSnakesLists(z1: Snake[], z2: Snake[], r: number): Snake[]
function interpolateSnakesLists(
  z1: (Snake | DyingSnake)[],
  z2: (Snake | DyingSnake)[],
  r: number
): (Snake | DyingSnake)[] {
  let snakes: (Snake | DyingSnake)[]
  if (r < 0.5) {
    snakes = z1.filter((s1) => !z2.some((s2) => s1.id === s2.id))
  } else {
    snakes = z2.filter((s2) => !z1.some((s1) => s1.id === s2.id))
  }
  z1.filter((s1) => z2.some((s2) => s1.id === s2.id)).forEach((s1) => {
    const s2 = z2.find((snake) => snake.id === s1.id)!
    snakes.push(interpolateSnakes(s1, s2, r))
  })
  return snakes
}

export function interpolateState(m1: Model, m2: Model, r: number): Model {
  if (r < 0.01) return m1
  else if (r > 0.99) return m2
  return {
    announcement: r > 0.5 ? m2.announcement : m1.announcement,
    food: r > 0.5 ? m2.food : m1.food,
    snakes: interpolateSnakesLists(m1.snakes, m2.snakes, r),
    dyingSnakes: interpolateSnakesLists(m1.dyingSnakes, m2.dyingSnakes, r),
  }
}

export function extrapolateState(m1: Model, deltaTime: number): Model {
  const model = cloneDeep(m1)
  const timeMult = deltaTime / 16
  model.dyingSnakes.forEach((s) => {
    s.alpha *= 0.9 ** timeMult
  })
  model.snakes.forEach((snake) => {
    // console.log(snake)
    let delta = (speed + 0.02 * Math.log2(snake.length)) * timeMult
    // delta /= 5

    const dim = snake.initialDirectionVertical ? 1 : 0
    const j = snake.jointLengths.length - 1
    const sign = snake.jointLengths[j] > 0 ? 1 : -1

    snake.jointLengths[j] += delta * sign
    snake.head[dim] -= delta * sign
  })
  if (deltaTime > 400) {
    model.announcement = 'Disconnected from server'
  }
  return model
}
